module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("T")]), _vm._v("he district of Islington has long had a somewhat Bohemian reputation and is, nowadays, one of the more fashionable areas of the city. Islington, however, has a darker side.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("This book contains details of some fifty men and women who faced a charge of murder, for crimes within Islington. Some of these were crimes of desperation and rage, such as the murder of the writer Joe Orton by his lover, Kenneth Halliwell; a sad story of a man eclipsed by his more famous partner, or the slashing of James Frederick Robinson by Nicky Xanaris, in a street fight. There are, however, also the cold-blooded killers who took the lives of others for more sinister reasons.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("There is the story of George Chapman, a man said by some to be the infamous Jack the Ripper. That is almost certainly nonsense, but it is true that he poisoned three women and watched them die slowly and painfully.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Yet such evil is not limited to the male of the species. The story of Celestina Somner is also told in these pages; a woman who calmly took her own daughter into a cellar, cut her throat, and then encouraged her to die, expressing impatience when the child did not die quickly enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Foul Deeds in Islington")]), _vm._v(" tells the stories of wives, killed by their husbands, men killed in drunken fights, children killed by those they should have been able to trust, and of deaths that remain unsolved to this day. Each of those stories is the story of someone’s life and death; lives cut short for no other reason than drunkenness, carelessness or anger. It also tells the stories of those who spent their final days in the condemned cell of one of London’s prisons, waiting for the hangman to come and end their suffering. Every one of the chapters signals the death of one or more persons, sometimes in the most brutal of fashions.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The streets of Islington today may well be places to aspire to, but some of those same streets hold tales of violent, brutish death, by the knife, the cosh, the gun, the blunt instrument, the bottle of deadly poison, and the unforgiving judicial rope.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Those dark tales are told within the pages of this book.")])])])]), _c('a', {
    attrs: {
      "id": "title2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aea9207","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783469529_fm02.vue
// module id = 69
// module chunks = 0